<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Создание потенциального клиента</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Монитор продаж /</span> Создание потенциального клиента</div>
                </div>
                <div>
                  <v-btn
                      color="#629F33"
                      class="button__success"
                      @click="createClient"
                      :disabled="isLoading || !checkedData || !generalInformation.phone"
                  >
                    Сохранить
                  </v-btn>
                </div>
              </v-col>
            </v-row>
<!--            <v-row>-->
<!--              <v-col cols="12">-->
<!--                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray">-->
<!--                  <div class="status-line">-->
<!--                    <div class="status-line__status" v-for="(stage, index) in deal.stages" :style="activeStageIndex >= index ? 'background-color: ' + stage.colour : ''" :key="stage.id" @click="setActiveStage(index, stage.id)">{{ stage.name }}</div>-->
<!--                  </div>-->
<!--                </v-sheet>-->
<!--              </v-col>-->
<!--            </v-row>-->
            <v-row align="stretch">
              <v-col
                  md="6"
              >
                <v-sheet rounded="lg" class="card">
                  <span class="card-title">Фото клиента</span>
                  <div class="edit-avatar">
                    <div class="user-avatar">
                      <img
                          v-if="!isCameraOpen"
                          :src="basePhoto ? basePhoto : '/playground_assets/mediumcamera3282-238l.svg'"
                          :style="basePhoto ? 'height: 210px; width: 210px; border-radius: 145px;' : 'height: 37px; width: 46px'"
                      />
                      <div v-show="isCameraOpen && isLoading2" class="camera-loading">
                        <ul class="loader-circle">
                          <li></li>
                          <li></li>
                          <li></li>
                        </ul>
                      </div>

                      <div v-if="isCameraOpen" v-show="!isLoading2" class="camera-box"
                           :class="{ 'flash' : isShotPhoto }">

                        <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>

                        <video v-show="!isPhotoTaken" style="border-radius:100%;" ref="camera" :width="210"
                               :height="210" autoplay></video>

                        <canvas v-show="isPhotoTaken" style="border-radius:100%;" id="photoTaken" ref="canvas"
                                :width="210" :height="210"></canvas>
                      </div>


                    </div>
                    <div class="edit-button">
                      <v-row style="align-items: center; justify-content: center;">
                        <v-btn type="button" class="button__lighten-success" @click="toggleCamera">
                          <span v-if="!isCameraOpen">Изменить фото</span>
                          <span v-else>Закрыть камеру</span>
                        </v-btn>
                        <div v-if="isCameraOpen && !isLoading2 && !isPhotoTaken" class="camera-shoot"
                             style="padding-top:20px;">
                          <button type="button" class="button" @click="takePhoto"
                                  style="width:40px; height:40px;padding:2px 0px;">
                            <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png"
                                 style="width:30px; height:30px;padding:0px;">
                          </button>
                        </div>
                      </v-row>
                    </div>
                  </div>
                </v-sheet>
              </v-col>
              <v-col
                  md="6"
                  
              >
                <v-sheet rounded="lg" class="card" style="padding: 0 !important;">
                  <div class="client-data">
                    <div class="block">
                      <div class="task-buttons">
                        <v-btn
                            dark
                            class="my-btn gray"
                            @click="addTask"
                            @blur="changeField"
                        >
                          <Icon
                              iconName="plus"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              strockeWidth="1"
                          />
                          Задача
                        </v-btn>
                        <v-btn
                            dark
                            class="my-btn gray"
                            @click="dialogNote = true"
                        >
                          <Icon
                              iconName="plus"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              strockeWidth="1"
                          />
                          Заметки
                        </v-btn>
                      </div>
                      <div class="task-list">
                        <div v-for="item in history" :key="item.name" class="task-list__day">
                          <template>
                            <div class="task-list__day__tasks">
                              <div v-if="item.type === 'task'" class="task-list__day__tasks__task">
                                <div class="task-header">
                                  <Icon
                                      iconName="clock"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      strockeWidth="1"
                                      strocke="#767676"
                                  />
                                  <span class="task-date">{{ item.date }}</span>
                                  <span class="task-title">Новая продажа</span>
                                </div>
                                <div class="task-content content-grid">
                                  <div class="check-div">
                                    <v-checkbox :id="`task-1`" :ref="`task-1`" color="#629F33"
                                                v-model="nomenclatureSelect" :value="1"></v-checkbox>
                                  </div>
                                  <div>
                                    <span class="task-topic">{{ item.name }}</span>
                                    <div>
                                      {{ item.description }}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-if="item.type === 'note'" class="task-list__day__tasks__task">
                                <div class="task-header">
                                  <Icon iconName="file-text" width="16" height="16"
                                        viewBox="0 0 16 16" strockeWidth="1" strocke="#767676"/>
                                  <span class="task-date">{{ item.date }}</span>
                                  <span class="task-title">Новая продажа</span>
                                </div>
                                <div class="task-content">
                                  <div class="task-text">
                                    {{ item.note }}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </template>
                        </div>
<!--                        <div class="task-list__day">-->
<!--                          <div class="task-list__day__day-name">-->
<!--                            <span>9 января 2023</span>-->
<!--                          </div>-->
<!--                          <div class="task-list__day__history">-->
<!--                            <div class="task-list__day__history__item">-->
<!--                              <div class="action">09.01.2023 16:59 Новая продажа № 49</div>-->
<!--                              <div class="separator">-->
<!--                                <Icon iconName="chevron-down" width="16" height="16"-->
<!--                                      viewBox="0 0 16 16" strockeWidth="1"/>-->
<!--                              </div>-->
<!--                              <div class="action">-->
<!--                                <div class="status">Контакт с клиентом</div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                            <div class="task-list__day__history__item">-->
<!--                              <div class="action">12.07.2022 23:59 Зарегистрирована заявка</div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
                      </div>
                    </div>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
            <v-row align="stretch">
              <v-col
                  md="6"
                  class="d-flex"
              >
                <v-sheet rounded="lg" class="card">
                  <div class="heading">
                    <span class="card-title">Общая информация</span>
                    <div class="status">Потенциальный</div>
                  </div>
                  <v-row class="mt-2">
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Фамилия</label>
                      <v-text-field
                          v-model="generalInformation.last_name"
                          label="Фамилия"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Имя*</label>
                      <v-text-field
                          v-model="generalInformation.first_name"
                          label="Имя"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Отчество</label>
                      <v-text-field
                          v-model="generalInformation.middle_name"
                          label="Отчество"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Дата рождения</label>
                      <template>
                        <VueDatePicker
                            no-title
                            no-header
                            color="#629f34"
                            :minDate="(new Date()).setYear((new Date()).getYear() - 100)"
                            :maxDate="new Date()"
                            v-model="generalInformation.birthday"
                            placeholder="Выбрать"
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              {{ date }}
                              <v-icon
                                  medium
                                  right
                                  class="ml-5"
                              >
                                mdi-calendar-blank-outline
                              </v-icon>
                            </button>
                          </template>
                        </VueDatePicker>
                      </template>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Номер телефона*</label>
                      <v-text-field
                          v-model="generalInformation.phone"
                          label="Номер телефона"
                          v-mask="'+7 (###) ###-##-###'"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Почта</label>
                      <v-text-field
                          v-model="generalInformation.email"
                          :rules="emailRules"
                          label="Почта"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="12"
                        sm="12"
                        v-if="listPlatforms"
                    >
                      <label>Канал привлечения</label>
                      <v-select
                          v-model="generalInformation.advertising_platform"
                          class="rounded-lg custom__select"
                          :items="listPlatforms.advertising ?? []"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Канал привлечения"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          style="height: 48px;"
                          @change="changeField"
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        md="12"
                        sm="12"
                        v-if="listSources"
                    >
                      <label>Рекламный источник</label>
                      <v-select
                          v-model="generalInformation.advertising_source"
                          class="rounded-lg custom__select"
                          :items="listSources.advertising ?? []"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Рекламный источник"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          style="height: 48px;"
                          @change="changeField"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <v-row align="stretch">
              <v-col
                  md="6"
              >
                <v-sheet rounded="lg" class="card">
                  <span class="card-title">
                    Данные по карте
                  </span>
                  <v-row
                      v-if="!generalInformation.card"
                  >
                    <v-col
                        md="12"
                        cols="12"
                    >
                      <span>Нету действующих карт по клиенту</span>
                    </v-col>
                  </v-row>
                  <v-row
                      v-else
                      class="mt-2"
                  >
                    <v-col
                        md="12"
                    >
                      <label>Номер карты</label>
                      <v-text-field
                          v-model="generalInformation.card"
                          :rules="cardNumberRules"
                          label="Номер карты"
                          outlined
                          dense
                          readonly
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>
                    <!--                    <v-col-->
                    <!--                        md="4"-->
                    <!--                        style="margin-top: 14px !important;"-->
                    <!--                    >-->
                    <!--                      <v-skeleton-loader-->
                    <!--                          v-if="isLoading"-->
                    <!--                      >-->
                    <!--                      </v-skeleton-loader>-->
                    <!--                      <v-btn-->
                    <!--                          :class="card.card_status === 2 ? 'button__unlock' : 'button__danger'"-->
                    <!--                          style="height: 40px !important;"-->
                    <!--                          @click="card.card_status === 2 ? unlock(card.card_id) : block(card.card_id)"-->
                    <!--                      >-->
                    <!--                        {{ card.card_status === 2 ? 'Разблокировать' : 'Заблокировать' }}-->
                    <!--                      </v-btn>-->
                    <!--                    </v-col>-->
                  </v-row>
                  <v-btn class="button__lighten-success" @click="dialogCard = true">
                    Добавить
                  </v-btn>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row align="stretch">
              <v-col
                  md="6"
                  class="d-flex"
              >
                <v-sheet rounded="lg" class="card">
                  <div class="heading">
                    <span class="card-title">Удостоверение личности</span>
                  </div>
                  <v-row class="mt-2">
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Вид документа</label>
                      <v-select
                          v-model="generalInformation.document_type"
                          class="rounded-lg custom__select"
                          :items="document_types_list ?? []"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Вид документа"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          style="height: 48px; margin-top:10px;"
                      >
                      </v-select>
                 
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Код подразделения</label>
                      <v-text-field
                          v-model="generalInformation.document_code"
                          label="Код подразделения"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Серия документа</label>
                      <v-text-field
                          v-model="generalInformation.document_serial"
                          label="Серия документа"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Номер документа</label>
                      <v-text-field
                          v-model="generalInformation.document_number"
                          label="Номер документа"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Дата выдачи</label>
                      <template>
                        <VueDatePicker
                            no-title
                            no-header
                            color="#629f34"
                            :minDate="(new Date()).setYear((new Date()).getYear() - 100)"
                            :maxDate="new Date()"
                            v-model="generalInformation.document_date"
                            placeholder="Выбрать"
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              {{ date }}
                              <v-icon
                                  medium
                                  right
                                  class="ml-5"
                              >
                                mdi-calendar-blank-outline
                              </v-icon>
                            </button>
                          </template>
                        </VueDatePicker>
                      </template>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Кем выдан</label>
                      <v-text-field
                          v-model="generalInformation.document_address"
                          label="Кем выдан"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
         
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row align="stretch">
              <v-col
                  md="6"
                  class="d-flex"
              >
                <v-sheet rounded="lg" class="card">
                  <div class="heading">
                    <span class="card-title">Адрес</span>
                  </div>
                  <v-row class="mt-2">
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Город</label>
                      <v-text-field
                          v-model="generalInformation.adrress_city"
                          label="Город"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                 
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Улица</label>
                      <v-text-field
                          v-model="generalInformation.adrress_street"
                          label="Улица"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Дом</label>
                      <v-text-field
                          v-model="generalInformation.adrress_building"
                          label="Дом"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Подъезд</label>
                      <v-text-field
                          v-model="generalInformation.adrress_enter"
                          label="Подъезд"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Строение</label>
                      <v-text-field
                          v-model="generalInformation.adrress_house"
                          label="Строение"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Квартира</label>
                      <v-text-field
                          v-model="generalInformation.adrress_flat"
                          label="Квартира"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>
         

                    
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Индекс</label>
                      <v-text-field
                          v-model="generalInformation.adrress_index"
                          label="Индекс"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                          @change="changeField"
                          @keyup="changeFieldKeyUp"
                      ></v-text-field>
                    </v-col>

                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row align="stretch">
              <v-col
                  md="6"
              >
                <v-sheet rounded="lg" class="card" style="padding: 0 !important;">
                  <div style="padding: 20px 20px 0 20px">
                    <span class="card-title">Родственники</span>
                  </div>
                  <v-data-table
                      :headers="headersRelations"
                      :items="generalInformation.relatives"
                      :hide-default-footer="true"
                      item-key="id"
                      class="elevation-1"
                  >
                  </v-data-table>
                  <v-btn class="button__lighten-success" @click="addRelation" style="margin: 20px 0 20px 20px">
                    Добавить
                  </v-btn>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
    <Modal ref="payment" :notFooterBorder="true">
      <template v-slot:header>
        Оплата
      </template>
      <template v-slot:body>
        <div class="payment-form">
          <div class="payment-form__item ">
            <div class="line">
              <span>Чек на</span>
              <v-btn-toggle mandatory background-color="#FFFFFF" class="rounded-lg"
                            style="margin-top: 40px; width: 100%">
                <v-btn width="50%">

                  <Icon iconName="phone" width="24" height="24" stroke="#629F33"/>
                  Телефон
                </v-btn>
                <v-btn width="50%">
                  <Icon iconName="email" width="24" height="20" stroke="#767676" viewBox="0 0 24 20"/>
                  Эл.почту
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <div class="payment-form__item">
            <v-btn-toggle mandatory background-color="#FFFFFF" class="rounded-lg"
                          style="margin-top: 40px; width: 100%">
              <v-btn width="25%">
                Наличные
              </v-btn>
              <v-btn width="25%">
                Л/C
              </v-btn>
              <v-btn width="25%">
                Карта
              </v-btn>
              <v-btn width="25%">
                Бонусы
              </v-btn>
            </v-btn-toggle>
          </div>
          <div class="payment-form__item">
            <label>Касса</label>
            <v-select class="rounded-lg custom__select" :items="boxOffices" item-title="title"
                      item-value="value" item-text="title" :hide-details="true"
                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }" placeholder="Касса"
                      append-icon="mdi-chevron-down" outlined style="height: 48px;margin-top: 10px">
            </v-select>
          </div>
          <div class="payment-form__item">
            <div class="collumn-3">
              <div class="col-item">
                <label>К оплате</label>
                <v-text-field v-model="toPayment" :hide-details="true" outlined class="input disabled"
                              placeholder="К оплате" disabled></v-text-field>
              </div>
              <div class="col-item">
                <label>Внесено</label>
                <v-text-field :style="{ height: '48px' }" :hide-details="true" outlined class="input"
                              placeholder="Внесено"></v-text-field>
              </div>
              <div class="col-item">
                <label>Сдача</label>
                <v-text-field :hide-details="true" outlined class="input"
                              placeholder="Сдача"></v-text-field>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <v-btn class="search-button" style="padding: 24px!important; width: 100%!important; margin: 0 !important;"
               @click="$refs.confirm._confirm()">
          Оплатить
        </v-btn>
      </template>
    </Modal>
    <v-row justify="center">
      <v-dialog
          v-model="dialogCard"
          persistent
          max-width="600px"
      >
        <v-card>
          <v-card-title class="text-center">
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogCard = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="padding-bottom: 70px;">
            <v-container>
              <v-form ref="addCardForm" @submit.prevent="addCard">
                <div class="text-center">
                  <h3 class="text-center">Добавить новую карту</h3>
                </div>
                <v-row
                    align="center"
                    class="mt-5"
                >
                  <v-col
                      cols="12"
                      sm="6"
                      md="8"
                  >
                    <v-text-field
                        v-model="card_number"
                        :rules="cardNumberRules"
                        label="Номер карты"
                        class="rounded-lg"
                        outlined
                        dense
                        style="height: 48px;margin-top: 10px"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                      md="4"
                  >
                    <button
                        class="button button__success purpure-button"
                        ref="activator"
                        type="button"
                        style="padding: 8px 20px !important; font-weight: 700;"
                        @click="searchBracelet"
                        :disabled="isClicked"
                    >
                      Сгенерировать
                    </button>
                  </v-col>

                  <button
                      class="button button__secondary"
                      ref="activator"
                      type="submit"
                      style="margin:auto; font-weight: 700;"
                  >
                    Сохранить
                  </button>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="dialogTask"
          max-width="900px"
      >
        <v-card rounded="lg">
          <v-card-title class="justify-space-between">
            <div></div>
            <div>
              <h4>Новая задача</h4>
            </div>
            <v-btn icon @click="dialogTask = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="addTaskForm" @submit.prevent="addTaskSubmit">
                <v-row
                    class="mt-5"
                >
                  <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="listTask"
                  >
                    <label>Вид задачи</label>
                    <v-select
                        class="rounded-lg custom__select"
                        v-model="newTask.type"
                        :items="listTask.monitor"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Выбрать"
                        append-icon="mdi-chevron-down"
                        outlined
                        dense
                        required
                        style="height: 48px;"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      sm="12"
                      md="12"
                  >
                    <label>Тема задачи</label>
                    <v-text-field
                        v-model="newTask.topic"
                        placeholder="Тема задачи"
                        class="rounded-lg"
                        outlined
                        dense
                        style="height: 48px;"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      sm="12"
                      md="12"
                  >
                    <label>Описание</label>
                    <v-textarea
                        v-model="newTask.message"
                        placeholder="Описание"
                        rounded
                        outlined
                        dense
                        required
                        auto-grow
                        background-color="#fff"
                        rows="5"
                        style="width: 100%; height: 150px"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="1"
                    class="d-flex align-center justify-center"
                  >
                    <v-icon
                        large
                        class="mr-2"
                    >
                      mdi-clock-time-four-outline
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                  >
                    <VueDatePicker
                        no-title
                        no-header
                        color="#629f34"
                        v-model="newTask.date"
                        placeholder="Выбрать"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__datepicker"
                            ref="activator"
                            type="button"
                        >
                          <div>
                            <span v-if="date">{{ date }}</span>
                            <span v-else style="color: gray">Дата</span>
                          </div>
                          <div>
                            <v-icon
                                medium
                                right
                                class="ml-5"
                            >
                              mdi-calendar-blank-outline
                            </v-icon>
                          </div>
                        </button>
                      </template>
                    </VueDatePicker>
                  </v-col>
<!--                  Пока скрываем, так как нету функционала по уведомлениям-->
<!--                  <v-col-->
<!--                    cols="12"-->
<!--                    md="3"-->
<!--                  >-->
<!--                    <button-->
<!--                      class="button button__secondary"-->
<!--                      type="button"-->
<!--                      @click="newTask.notification = !newTask.notification"-->
<!--                    >-->
<!--                      <v-icon-->
<!--                          medium-->
<!--                      >-->
<!--                        mdi-bell-outline-->
<!--                      </v-icon>-->
<!--                      {{ newTask.notification ? 'Напомнить' : 'Не напоминать' }}-->
<!--                    </button>-->
<!--                  </v-col>-->
                </v-row>
                <!--                  Фича для руководителя-->
<!--                <v-row>-->
<!--                  <v-col-->
<!--                      cols="12"-->
<!--                      md="1"-->
<!--                      class="d-flex align-center justify-center"-->
<!--                  >-->
<!--                    <v-icon-->
<!--                        large-->
<!--                        class="mr-2"-->
<!--                    >-->
<!--                      mdi-account-outline-->
<!--                    </v-icon>-->
<!--                  </v-col>-->
<!--                  <v-col-->
<!--                      cols="12"-->
<!--                      md="5"-->
<!--                  >-->
<!--                    <v-text-field-->
<!--                        v-model="userFIO"-->
<!--                        :rules="[]"-->
<!--                        class="rounded-lg"-->
<!--                        outlined-->
<!--                        dense-->
<!--                        readonly-->
<!--                        style="height: 48px;"-->
<!--                    ></v-text-field>-->
<!--                    <v-select-->
<!--                        class="rounded-lg custom__select"-->
<!--                        v-model="newTask.manager"-->
<!--                        :items="[]"-->
<!--                        item-value="type_id"-->
<!--                        item-text="type_name"-->
<!--                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"-->
<!--                        label="Выбрать"-->
<!--                        append-icon="mdi-chevron-down"-->
<!--                        outlined-->
<!--                        dense-->
<!--                        required-->
<!--                        style="height: 48px;"-->
<!--                    ></v-select>-->
<!--                  </v-col>-->
<!--                </v-row>-->
                <v-row>
                  <button
                      class="button button__success"
                      ref="activator"
                      type="submit"
                      style="margin-left: auto;font-weight: 700;"
                  >
                    Сохранить
                  </button>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="dialogNote"
          max-width="600px"
      >
        <v-card rounded="lg">
          <v-card-title class="justify-space-between">
            <div></div>
            <div>
              <h4>Новая заметка</h4>
            </div>
            <v-btn icon @click="dialogNote = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="addNoteForm" @submit.prevent="addNote">
                <v-row
                    class="mt-5"
                >
                  <v-col
                      cols="12"
                      sm="12"
                      md="12"
                  >
                    <label>Текст заметки</label>
                    <v-textarea
                        v-model="newNote.note"
                        :rules="noteRules"
                        placeholder="Написать..."
                        rounded
                        outlined
                        dense
                        required
                        auto-grow
                        background-color="#fff"
                        rows="5"
                        style="width: 100%; height: 150px"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <button
                      class="button button__success"
                      ref="activator"
                      type="submit"
                      style="margin-left: auto;font-weight: 700;"
                  >
                    Сохранить
                  </button>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="dialogRelation"
          persistent
          max-width="600px"
      >
        <v-card rounded="lg">
          <v-card-title class="justify-space-between">
            <div></div>
            <div>
              <h4>Родственник</h4>
            </div>
            <v-btn icon @click="dialogRelation = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="relationForm" @submit.prevent="addRelationSubmit">
                <v-row>
                  <v-col
                      cols="12"
                      sm="12"
                      md="12"
                  >
                    <label>Родственник <span style="color: #D53025">*</span></label>
                    <div class="d-flex">
                      <v-autocomplete
                          colspan="1"
                          :items="listClient ? listClient.client : []"
                          item-text="name"
                          placeholder="Поиск клиентов"
                          no-data-text="Результатов не найдено"
                          clearable
                          color="#629F33"
                          item-color="success"
                          :search-input.sync="search"
                          v-model="select"
                          return-object
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg'}"
                          :no-filter=true
                          class="rounded-lg"
                          append-icon=""
                          hide-details
                          outlined
                          dense
                          background-color="white"
                          style="height: 30px;margin-top: 10px"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>mdi-magnify</v-icon>
                        </template>
                      </v-autocomplete>
                      <v-btn v-if="select !== null" :to="{ name: 'Desktop', params: {client_id: select.client_id} }"
                             class="button__lighten-success ml-3"
                             style="height: 40px !important;margin-top: 10px !important;">
                        Рабочий стол
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col
                      cols="12"
                      sm="6"
                  >
                    <label>Степень родства <span style="color: #D53025">*</span></label>
                    <v-select
                        v-if="listRelativesTypes"
                        v-model="newRelative.relative_type"
                        :rules="relativeTypeRules"
                        :items="listRelativesTypes.relatives"
                        item-text="name"
                        return-object
                        label="Степень родства"
                        class="rounded-lg"
                        outlined
                        dense
                        required
                        style="height: 30px;margin-top: 10px"
                    ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                      md="6"
                  >
                    <v-switch
                        v-model="newRelative.is_representative"
                        label="Законный представитель"
                        color="#629F33"
                        inset
                        style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col
                      cols="12"
                      sm="6"
                  >
                    <label>Лицевой счет</label>
                    <v-select
                        v-model="newRelative.main_bill"
                        :items="billTypes"
                        item-value="type_value"
                        item-text="type_name"
                        label="Лицевой счет"
                        class="rounded-lg"
                        outlined
                        dense
                        required
                        style="height: 30px;margin-top: 10px"
                    ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                  >
                    <label>Бонусный счет</label>
                    <v-select
                        v-model="newRelative.bonus_bill"
                        :items="billTypes"
                        item-value="type_value"
                        item-text="type_name"
                        label="Бонусный счет"
                        class="rounded-lg"
                        outlined
                        dense
                        required
                        style="height: 30px;margin-top: 10px;"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-card-actions style="padding: 20px 10px !important;">
                    <button
                        class="button button__success"
                        ref="activator"
                        type="submit"
                    >
                      Сохранить
                    </button>
                  </v-card-actions>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="dialogRelationEdit"
          persistent
          max-width="600px"
      >
        <v-card rounded="lg">
          <v-card-title class="justify-space-between">
            <div></div>
            <div>
              <h4>Родственник</h4>
            </div>
            <v-btn icon @click="dialogRelationEdit = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form" @submit.prevent="editRelationSubmit">
                <v-row>
                  <v-col
                      cols="12"
                      sm="12"
                      md="12"
                  >
                    <label>Родственник <span style="color: #D53025">*</span></label>
                    <div class="d-flex">
                      <v-text-field
                          v-model="editRelative.name"
                          label="Родственник"
                          class="rounded-lg"
                          outlined
                          dense
                          readonly
                          style="height: 48px;margin-top: 10px"
                      ></v-text-field>
                      <v-btn v-show="editRelative.id !== null" :to="{ name: 'Desktop', params: {client_id: editRelative.id} }"
                             class="button__lighten-success ml-3"
                             style="height: 40px !important;margin-top: 10px !important;">
                        Рабочий стол
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                  >
                    <label>Степень родства <span style="color: #D53025">*</span></label>
                    <v-select
                        v-if="listRelativesTypes"
                        v-model="editRelative.relative_type"
                        :rules="relativeTypeRules"
                        :items="listRelativesTypes.relatives"
                        item-value="id"
                        item-text="name"
                        label="Степень родства"
                        class="rounded-lg"
                        outlined
                        dense
                        required
                        style="height: 30px;margin-top: 10px"
                    ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                      md="6"
                  >
                    <v-switch
                        v-model="editRelative.is_representative"
                        label="Законный представитель"
                        color="#629F33"
                        inset
                        style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                    ></v-switch>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                  >
                    <label>Лицевой счет</label>
                    <v-select
                        v-model="editRelative.main_bill"
                        :items="billTypes"
                        item-value="type_id"
                        item-text="type_name"
                        label="Лицевой счет"
                        class="rounded-lg"
                        outlined
                        dense
                        required
                        style="height: 30px;margin-top: 10px"
                    ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                  >
                    <label>Бонусный счет</label>
                    <v-select
                        v-model="editRelative.bonus_bill"
                        :items="billTypes"
                        item-value="type_id"
                        item-text="type_name"
                        label="Бонусный счет"
                        class="rounded-lg"
                        outlined
                        dense
                        required
                        style="height: 30px;margin-top: 10px;"
                    ></v-select>
                  </v-col>
                  <v-card-actions style="padding: 20px 10px !important;">
                    <button
                        class="button button__success"
                        ref="activator"
                        type="submit"
                    >
                      Сохранить
                    </button>
                    <button
                        class="button button__danger ml-3"
                        ref="activator"
                        type="button"
                        style="margin-top: 0px !important; padding: 8px 20px !important; border-radius: 12px !important;"
                        @click="deleteRelationSubmit"
                    >
                      Удалить
                    </button>
                  </v-card-actions>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="showClientPhoneModal"
          persistent
          max-width="800px"
      >
        <v-card rounded="lg">
          <v-card-title class="justify-space-between">
            <div></div>
            <div>
              <h4>Клиент(ы) с такими данными (номер телефона) уже существует!</h4>
            </div>
            <v-btn icon @click="showClientPhoneModal = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form_phone" >
                <v-row v-for="(line,index) of existClients" :key="line.client_id" style="display:flex; align-items:center; justify-content: space-between; font-size: 16px;">
                  <div>{{ index + 1 }}</div>
                  <div>
                    {{ line.name}}
                  </div>
                  <div>
                    {{ line.phone}}
                  </div>
                  <v-card-actions style="padding: 20px 10px !important;">
                    <button
                        class="button button__success ml-3"
                        ref="activator"
                        type="button"
                        style="margin-top: 0px !important; padding: 8px 20px !important; border-radius: 12px !important;"
                        @click="openExist(line.client_id)"
                    >
                      Открыть существуюшего
                    </button>
                  
                  

                  </v-card-actions>
                </v-row>
                <v-row style="display:flex; align-items: center; justify-content: center;">
                  <button
                        class="button button__danger ml-3"
                        ref="activator"
                        type="button"
                        style="margin-left:10px;"
                        @click="existClients = [], generalInformation.phone = null, showClientPhoneModal = false"
                    >
                      Отменить
                    </button>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>
<script>
import {globalMethods} from "@/mixins/globalMethods";
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import Icon from '@/components/Icons.vue';
import Modal from '@/components/ModalDialog.vue';
import {mapState} from "vuex";
import {clientActionTypes} from '@/store/modules/client';
import {relativesActionTypes} from '@/store/modules/relatives';
import {monitorActionTypes} from "@/store/modules/monitor";
import {advertisingActionTypes} from "@/store/modules/advertising";
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';

export default {
  name: 'CreateClient',
  mixins: [globalMethods],
  props: ['deal','client_phone'],
  components: {
    VueDatePicker,
    Header,
    Menu,
    Icon,
    Modal
  },
  data() {
    return {
      activeStageIndex: 0,
      basePhoto: null,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading2: false,
      isClicked: false,
      dialogRelationEdit: false,
      generalInformation: {
        deal: {
          type_id: null,
          stage_id: null,
        },
        phone: null,
        last_name: null,
        first_name: null,
        middle_name: null,
        birthday: null,
        email: null,
        advertising_platform: null,
        advertising_source: null,
        card: null,
        relatives: [],
        notes: [],
        tasks: [],
        document_address:null,
        document_number:null,
        document_type:null,
        document_code:null,
        document_date:null,
        document_serial:null,
        adrress_index:null,
        adrress_city:null,
        adrress_street:null,
        adrress_building:null,
        adrress_enter:null,
        adrress_flat:null,
        adrress_house:null,
      },
      document_types_list:[
      {
        id:"1",
        name:"пасспорт"
      }
      ],
      emailRules: [
        v => !!v || 'Электронная почта обязательное поле',
        v => /.+@.+\..+/.test(v) || 'Электронная почта не правильно заполнена',
      ],
      card: null,
      card_number: null,
      cardNumberRules: [
        v => !!v || 'Номер карты обязательное поле',
      ],
      headersRelations: [
        {text: 'ФИО', align: 'start', sortable: false, value: 'name', width: '40%'},
        {text: 'Степень родства', align: 'start', sortable: false, value: 'type_name', width: '30%'},
        {text: 'Телефон', align: 'start', sortable: false, value: 'phone', width: '30%'},
      ],
      dialogCard: false,
      dialogTask: false,
      dialogNote: false,
      editCardNumber: null,
      newCardNumber: null,
      dialogRelation: false,
      search: '',
      select: null,
      showDtError: false,
      dateFromRules: [
        v => !!v || 'Дата начала обязательное поле'
      ],
      tasks: [],
      newTask: {
        deal: null,
        type: null,
        topic: null,
        message: null,
        date: null,
        time: null,
        notification: false,
        manager: null,
      },
      notes: [],
      newNote: {
        note: null
      },
      noteRules: [
        v => !!v || 'Заметки обязательное поле'
      ],
      history: [],
      items: [],
      currentDate: new Date(),
      newRelative: {
        phone: null,
        birthday: null,
        gender: null,
        relative_type: null,
        is_representative: false,
        main_bill: null,
        bonus_bill: null,
      },
      editRelative: {
        phone: null,
        birthday: null,
        gender: null,
        relative_type: null,
        is_representative: false,
        main_bill: null,
        bonus_bill: null,
      },
      billTypes: [
        {type_value: true, type_name: 'Общий'},
        {type_value: false, type_name: 'Раздельный'},
      ],
      genderTypes: [
        {type_id: 1, type_name: 'Мужской'},
        {type_id: 2, type_name: 'Женский'},
      ],
      firstNameRules: [
        v => !!v || 'Имя обязательное поле'
      ],
      genderRules: [
        v => !!v || 'Пол обязательное поле'
      ],
      phoneRules: [
        v => !!v || 'Телефон обязательное поле'
      ],
      relativeTypeRules: [
        v => !!v || 'Степень родства обязательное поле'
      ],
      rules: [
        value => {
          if (value) return true

          return 'Поле обязательно для заполнения'
        },
      ],
      existingCustomer: false,
      toPayment: "999 500 ₽",
      DegreeKinship: [
        {title: 'Родитель', value: '1'},
        {title: 'Супруг', value: '2'},
        {title: 'Ребенок', value: '3'},
        {title: 'Родственик', value: '4'},
      ],
      ls: [
        {title: 'Счет 1', value: '1'},
      ],
      bs: [
        {title: 'Счет 1', value: '1'},
      ],
      attractionChannel: [
        {title: 'Сайт', value: '1'},
        {title: 'Email рассылка', value: '2'},
        {title: 'Тизерные сети', value: '3'},
      ],
      advertisingSource: [
        {title: 'Яндекс', value: '1'},
        {title: 'SEO', value: '2'},
      ],
      cardType: [
        {title: 'Яндекс', value: '1'},
        {title: 'SEO', value: '2'},
      ],
      documentType: [
        {title: 'Паспорт', value: '1'},
      ],
      сitizenship: [
        {title: 'РФ', value: '1'},
      ],
      boxOffices: [
        {title: 'Касса №1', value: '1'},
        {title: 'Касса №2', value: '2'},
        {title: 'Касса №3', value: '3'},
      ],
      nomenclatureSelect: [],
      showMoreDetailed: [],
      list: [
        {
          id: 1,
          name: '№124151515 Продажа 662 от 24.11.2022'
        },
        {
          id: 2,
          name: '№124151515 Продажа 662 от 24.11.2022'
        },
      ],
      showClientPhoneModal:false,
      existClients:[],
      checkedData:false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      listClient: state => state.client.listClient,
      listTask: state => state.monitor.listTask,
      listPlatforms: state => state.advertising.listPlatforms,
      listSources: state => state.advertising.listSources,
      listRelativesTypes: state => state.relatives.listRelativesTypes,
      userFIO: state => state.userFIO,
    }),
  },
  watch: {
    search: function (value) {
      if (!!value) {
        value = value.trim()
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: value
        })
      }
    }
  },
  mounted() {
   
    console.log(this.$route.query)

    if(this.$route.query && this.$route.query.phone){
      this.client_phone = this.$route.query.phone
    }

    if(this.deal){
      this.generalInformation.deal.type_id = this.deal.id
      this.generalInformation.deal.stage_id = this.deal.stages[0].id
    }

    if(this.$route.query && this.$route.query.deal){
      this.generalInformation.deal.type_id = this.$route.query.deal
      this.generalInformation.deal.stage_id = this.$route.query.stage
    }

    this.deal !== undefined ? setItem('deal',this.deal) : this.deal = getItem('deal');
    this.$store.dispatch(advertisingActionTypes.getPlatforms);
    this.$store.dispatch(advertisingActionTypes.getSources);

    
    if(this.client_phone){
      console.log(this.client_phone)

      console.log(this.generalInformation)
      this.generalInformation.phone = this.client_phone.substr(1);
    }

  },
  methods: {
    openExist(client_id){
      this.$router.push({name: 'CardClientNew', params: {client_id: client_id}})
    },
    checkPhone(phone){

      this.existClients = []

      if(!this.generalInformation.phone || this.generalInformation.phone === null){
        return
      }

     let digitsOnlyPhone = phone.replace(/\D/g, '')
      // console.log(digitsOnlyPhone.length)
      // if(digitsOnlyPhone.length < 11){
      //   this.generalInformation.phone = null
      //   return
      // }

      this.$store.dispatch(clientActionTypes.searchClient, {
        client_field: phone
      }).then((response) => {
        if(response && response.client && response.client.length > 0){
          
            let phoneAr = []
          for(let i = 0; i < response.client.length; i++){
            const digitsOnly = response.client[i].phone.replace(/\D/g, '')
            let clientObj = {
              phone_cleared:digitsOnly,
              phone:response.client[i].phone,
              name:response.client[i].name,
              client_id:response.client[i].client_id
            }
            phoneAr.push(clientObj)
          }

          console.log(phoneAr)

          this.existClients = phoneAr.filter((item) => item.phone_cleared === digitsOnlyPhone);

          console.log(this.existClients)

          if(this.existClients.length > 0){
            this.showClientPhoneModal = true
          }
        }
        this.checkedData = true
      });
    },
    changeFieldKeyUp(){
      this.checkedData = false
    },
    changeField(){
      
      if(this.generalInformation.phone && this.generalInformation.phone.length > 5){
        this.checkPhone(this.generalInformation.phone)
      }
    },
    setActiveStage(index, id) {
      this.generalInformation.deal.stage_id = id;
      this.activeStageIndex = index;
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      this.isLoading2 = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true
      });

      navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            this.isLoading2 = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            this.isLoading2 = false;
            alert("May the browser didn't support or there is some errors.");
          });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 210, 210);

      const getBase64StringFromDataURL = (dataURL) =>
          dataURL.replace('data:', '').replace(/^.+,/, '');

      this.basePhoto = getBase64StringFromDataURL(document.getElementById("photoTaken").toDataURL("image/jpeg"));

    },
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },
    createClient() {

      // if(!this.generalInformation.last_name || this.generalInformation.last_name.length < 1){
      //   alert('Заполните фамилию!');
      //   return;
      // }
      if(!this.generalInformation.first_name || this.generalInformation.first_name.length < 1){
        alert('Заполните имя!');
        return;
      }
      if(!this.generalInformation.phone || this.generalInformation.phone.length < 1){
        alert('Заполните номер телефона!');
        return;
      }

      this.existClients = []
      if(!this.generalInformation.phone || this.generalInformation.phone === null){
        return
      }

     let digitsOnlyPhone = this.generalInformation.phone.replace(/\D/g, '')
      // if(digitsOnlyPhone.length < 11){
      //   this.generalInformation.phone = null
      //   return
      // }

      this.$store.dispatch(clientActionTypes.searchClient, {
        client_field: this.generalInformation.phone
      }).then((response) => {

        //return 
        if(response && response.client && response.client.length > 0){
          
            let phoneAr = []
          for(let i = 0; i < response.client.length; i++){
            const digitsOnly = response.client[i].phone.replace(/\D/g, '')
            let clientObj = {
              phone_cleared:digitsOnly,
              phone:response.client[i].phone,
              name:response.client[i].name,
              client_id:response.client[i].client_id
            }
            phoneAr.push(clientObj)
          }

          this.existClients = phoneAr.filter((item) => item.phone_cleared === digitsOnlyPhone);

          console.log(this.existClients)

          if(this.existClients.length > 0){
            this.showClientPhoneModal = true
          } else {

            this.$store.dispatch(clientActionTypes.createClient, {
              from: 'sale',
              last_name: this.generalInformation.last_name,
              first_name: this.generalInformation.first_name,
              middle_name: this.generalInformation.middle_name,
              birthday: this.generalInformation.birthday,
              gender: 1,
              phone: this.generalInformation.phone,
              email: this.generalInformation.email,
              client_card: this.generalInformation.card,
              photo: this.basePhoto,
              deal: this.generalInformation.deal,
              advertising_platform: this.generalInformation.advertising_platform,
              advertising_source: this.generalInformation.advertising_source,
              relatives: this.generalInformation.relatives,
              notes: this.generalInformation.notes,
              tasks: this.generalInformation.tasks,
              document_address: this.generalInformation.document_address,
              document_number:this.generalInformation.document_number,
              document_type:this.generalInformation.document_type,
              document_code:this.generalInformation.document_code,
              document_date:this.generalInformation.document_date,
              document_serial:this.generalInformation.document_serial,
              adrress_index:this.generalInformation.adrress_index,
              adrress_city:this.generalInformation.adrress_city,
              adrress_street:this.generalInformation.adrress_street,
              adrress_building:this.generalInformation.adrress_building,
              adrress_enter:this.generalInformation.adrress_enter,
              adrress_flat:this.generalInformation.adrress_flat,
              adrress_house:this.generalInformation.adrress_house
            })
            .then((response) => {
              if (response.success) {
                this.$router.push({name: 'CardClientNew', params: {client_id: response.client.client_id}})
              }
            })

          }


        } else {

            this.$store.dispatch(clientActionTypes.createClient, {
              from: 'sale',
              last_name: this.generalInformation.last_name,
              first_name: this.generalInformation.first_name,
              middle_name: this.generalInformation.middle_name,
              birthday: this.generalInformation.birthday,
              gender: 1,
              phone: this.generalInformation.phone,
              email: this.generalInformation.email,
              client_card: this.generalInformation.card,
              photo: this.basePhoto,
              deal: this.generalInformation.deal,
              advertising_platform: this.generalInformation.advertising_platform,
              advertising_source: this.generalInformation.advertising_source,
              relatives: this.generalInformation.relatives,
              notes: this.generalInformation.notes,
              tasks: this.generalInformation.tasks,
              document_address: this.generalInformation.document_address,
              document_number:this.generalInformation.document_number,
              document_type:this.generalInformation.document_type,
              document_code:this.generalInformation.document_code,
              document_date:this.generalInformation.document_date,
              document_serial:this.generalInformation.document_serial,
              adrress_index:this.generalInformation.adrress_index,
              adrress_city:this.generalInformation.adrress_city,
              adrress_street:this.generalInformation.adrress_street,
              adrress_building:this.generalInformation.adrress_building,
              adrress_enter:this.generalInformation.adrress_enter,
              adrress_flat:this.generalInformation.adrress_flat,
              adrress_house:this.generalInformation.adrress_house
            })
            .then((response) => {
              if (response.success) {
                this.$router.push({name: 'CardClientNew', params: {client_id: response.client.client_id}})
              }
            })


        }
      });


    },
    addRelation() {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList)
        .then((response) => {
          if (response.success)
            this.dialogRelation = true;
        });
    },
    addRelationSubmit() {
      if (this.$refs.relationForm.validate()) {
        this.generalInformation.relatives.push({
          id: this.select.client_id,
          name: this.select.name,
          phone: this.select.phone,
          type_id: this.newRelative.relative_type.id,
          type_name: this.newRelative.relative_type.name,
          is_representative: this.newRelative.is_representative,
          shared_main_bill: this.newRelative.main_bill,
          shared_bonus_bill: this.newRelative.bonus_bill,
        });
        this.$refs.relationForm.reset();
        this.newRelative.relative_type = null;
        this.newRelative.is_representative = null;
        this.newRelative.main_bill = null;
        this.newRelative.bonus_bill = null;
        this.select = null;
        this.dialogRelation = false;
        this.search = null;
      }
    },
    editRelation(item) {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList);
      this.editRelative.id = item.id;
      this.editRelative.relative_type = item.type_id;
      this.editRelative.is_representative = item.is_representative;
      this.editRelative.main_bill = item.shared_main_bill ? 1 : 2;
      this.editRelative.bonus_bill = item.shared_bonus_bill ? 1 : 2;
      this.dialogRelationEdit = true;
    },
    editRelationSubmit() {
      if (this.$refs.relationForm.validate()) {
        this.generalInformation.relatives.push({
          id: this.select.client_id,
          type_id: this.newRelative.relative_type,
          is_representative: this.newRelative.is_representative,
          shared_main_bill: this.newRelative.main_bill,
          shared_bonus_bill: this.newRelative.bonus_bill,
        });
        this.dialogRelationEdit = false;
      }
    },
    deleteRelationSubmit(id) {
      this.generalInformation.relatives.filter((item) => item.id !== id);
    },
    searchBracelet() {
      this.isClicked = true;
      this.$emit('stopInterval', 1)
      console.log('stopped')
      if (!this.counterInterval) {
        this.counterInterval = setInterval(this.sendRequest, 1000);
      }
    },
    editCard(cardNumber) {
      this.$set(this, 'editCardNumber', cardNumber)
      this.$refs['edit-card'].show({}).then((result) => {
      })
    },
    cardNumberGenerate() {
      var length = 15,
          charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
          retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.$set(this, 'newCardNumber', retVal)
    },
    addTask() {
      this.$store.dispatch(monitorActionTypes.getListTask)
      .then((response) => {
        if (response.success)
          this.dialogTask = true;
      });
    },
    addTaskSubmit() {
      if (this.$refs.addTaskForm.validate()) {
        this.history.push({
          type: 'task',
          name: this.newTask.topic,
          description: this.newTask.message,
          date: this.newTask.date
        })
        this.generalInformation.tasks.push({
          name: this.newTask.topic,
          description: this.newTask.message,
          date_end: this.newTask.date,
          status: false,
          type_id: this.newTask.type,
        })
        this.$refs.addTaskForm.reset();
        this.newTask.topic = null;
        this.newTask.message = null;
        this.newTask.date = null;
        this.newTask.type = null;
        this.dialogTask = false;
      }
    },
    addNote() {
      if (this.$refs.addNoteForm.validate()) {
        this.history.push({
          type: 'note',
          note: this.newNote.note,
          date: new Date()
        })
        this.generalInformation.notes.push(this.newNote.note)
        this.$refs.addNoteForm.reset()
        this.newNote.note = null;
        this.dialogNote = false;
      }
    },
    checkTime(date) {
      let value = new Date(date);
      return value > this.currentDate;
    },
    async addCard() {
      if (this.$refs.addCardForm.validate()) {
        this.generalInformation.card = this.card_number;
        this.dialogCard = false;
        this.card_number = null;
      }
    },
    showEditModal() {
      this.$refs['client-edit'].show({}).then((result) => {
      })
    },
    showPaymentModal() {
      this.$refs['payment'].show({}).then((result) => {
      })
    },
    showModal(modalName) {
      this.$refs[modalName].show({}).then((result) => {
      })
    },
    showMoreInfo(id) {
      if (this.showMoreDetailed.includes(id)) {
        this.$delete(this.showMoreDetailed, this.showMoreDetailed.indexOf(id))
      } else {
        this.$set(this, 'showMoreDetailed', [...this.showMoreDetailed, id])
      }
    },
    selectAll(check) {
      if (check == true) {
        this.$set(this, 'nomenclatureSelect', this.list.reduce((result, item) => {
          return [...result, item.id]
        }, []))
      } else {
        this.$set(this, 'nomenclatureSelect', [])
      }
    },
  }
}

</script>
<style scoped lang="scss">
.status-line {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__status {
    border: 1px solid #E0E0E0;
    border-radius: 12px;
    padding: 8px 12px;
    color: #767676;
    cursor: default;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &.active {
      background: #FFFEB2;
      color: #000;
      border-color: #FFFEB2;
    }
  }
}

.td-30 {

  td,
  th {
    width: 33.3333%;
  }

  .reletive-name {
    display: flex;
    align-items: center;

    .ava {
      width: 24px;
      min-width: 24px;
      max-width: 24px;
      height: 24px;
      min-height: 24px;
      max-height: 24px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 8px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }
}

.heading {
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    color: #1A1A1A;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }

  .status {
    background: #FFB800;
    border-radius: 25px;
    padding: 4px 10px;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;

  }
}

.form-btn {
  box-shadow: none;
  border-radius: 8px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  text-transform: none;

  &.red {
    background: #D53025 !important;
    color: #fff;
  }

  &.border-green {
    color: #629F33;
    border: 1px solid #629F33;
    background: #fff !important;
  }
}

.form {
  padding-top: 20px;

  &__field {
    &.padding-top-30 {
      padding-top: 30px;
    }

    &.colspan-2 {
      grid-column: 1 / 3;

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
      height: 48px;
    }

    .label {
      color: #1A1A1A;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      display: block;
      margin-bottom: 8px;
    }

    .v-select__slot {
      height: 48px !important;
      max-height: 48px !important;
      margin-top: -1px !important;

      fieldset {
        height: 48px !important;
        max-height: 48px !important;
        margin-top: -1px !important;
      }
    }

    .v-input__append-inner {
      margin: 0 !important;
    }

    .v-input__slot {
      height: 48px !important;
      max-height: 48px !important;

      fieldset {
        height: 48px !important;
        max-height: 48px !important;
        border-radius: 12px;
      }

      .v-text-field__slot {
        height: 48px !important;
      }
    }

    .v-icon.v-icon {
      margin-top: 20px;
    }
  }

}

.padding-20 {
  padding: 20px;
}

.client-info {
  .personal-data {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__photo {
      width: 210px;
      height: 210px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #F1F1F1;
      margin: 20px 0;

      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 50%;
      }
    }

    .border-green {
      border: 1px solid #629F33;
      border-radius: 12px;
      background: #fff;
      padding: 7px 20px;
      box-shadow: none;
      color: #629F33;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 13px;
      line-height: 16px;
      text-transform: none;
    }
  }

  .personal-info {
    padding: 20px;

    .item {
      width: 100%;
      font-family: 'Circe';
      font-weight: 400;
      font-style: normal;

      &:not(:last-child) {
        margin-bottom: 20px;
      }

      &__grid {
        display: grid;
        grid-template-columns: 1fr 63px;
      }

      &__head {
        color: #1A1A1A;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 14px;

        .right {
          &.buttons-block {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          &.justify-flex-end {
            display: flex;
            justify-content: flex-end;
          }

          button.gray {
            padding: 4px 8px;
            border-radius: 25px;
            font-size: 13px;
            line-height: 16px;
            color: #1A1A1A;
            height: 24px !important;
          }
        }
      }

      &__value {
        color: #767676;
        font-size: 13px;
        line-height: 16px;

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        .right {
          &.text-right {
            text-align: right;
          }

          &.color-black {
            color: #1A1A1A;
          }
        }
      }

      .btn-icon {
        width: 24px;
        height: 24px;
        background: #F1F1F1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .3s;

        &:hover {
          background: #e0e0e0;
        }
      }
    }
  }
}

.client-data {
  .personal-account {
    &__status {
      padding: 20px;
      color: #D53025;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    table {
      border-collapse: collapse;
      width: 100%;

      thead {
        th {
          background: #F1F1F1;
          font-weight: bold;
        }
      }

      th,
      td {
        background: #fff;
        padding: 10px 12px;
        text-align: left;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: #000000;
        border: 1px solid #E0E0E0 !important;

        &:first-child {
          border-left: 0 !important;
          width: 50px;
          max-width: 50px;
        }

        &:nth-child(2) {
          width: 100%;
        }

        &:nth-child(3) {
          min-width: 107px;
        }

        &:last-child {
          border-right: 0 !important;
          min-width: 107px;
        }

        .v-input__slot {
          margin: 0 !important;
        }

        .v-messages {
          display: none;
        }

        .v-input--selection-controls__ripple {
          display: none;
        }

        .v-input--checkbox {
          margin-top: 0 !important;
        }
      }

      td {
        vertical-align: top;

        .cheque {
          width: 100%;

          &__name {
            display: flex;
            align-items: center;

            span {
              flex: 1;
            }

            button {
              svg {
                transition: all .3s;
              }

              &.open {
                svg {
                  transform: rotate(180deg);
                }
              }
            }
          }
        }
      }

    }

    &__payment {
      padding: 20px;
      display: flex;
      justify-content: flex-end;

      button.red {
        background: #D53025;
        border-radius: 12px;
        text-transform: none;
        color: #fff;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        border: none;
        box-shadow: unset;
      }
    }
  }

  .buttons-block {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    button {
      &:not(:last-child) {
        margin-right: 20px;
      }
    }
  }

  .task-buttons {
    padding: 20px;
    border-bottom: 1px solid #E0E0E0;

    button {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .task-list {
    padding: 20px;

    &__day {
      &:not(:last-child) {
        margin-bottom: 20px;
      }

      &__day-name {
        display: flex;
        justify-content: center;
        padding-bottom: 18px;

        span {
          background: #F1F1F1;
          border-radius: 15px;
          color: #1A1A1A;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          padding: 4px 10px;
        }
      }

      &__tasks {

        width: 100%;


        &__task {
          width: 100%;
          border-radius: 12px;
          border: 1px solid #E0E0E0;

          &:not(:last-child) {
            margin-bottom: 10px;
          }

          .task-header {
            padding: 11px 13px;
            display: flex;
            align-items: center;
            background: #F1F1F1;
            color: #767676;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 10px;
            line-height: 12px;

            svg {
              margin-right: 10px;
            }

            .task-date {
            }

            .task-title {
              flex: 1;
              text-align: right;
              color: #1A1A1A;
            }
          }

          .task-content {
            display: grid;
            grid-template-columns: 100%;
            padding-top: 10px;
            color: #1A1A1A;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;

            .task-text {
              padding-left: 11px;
              padding-bottom: 10px;
              font-family: 'Circe';
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              line-height: 16px;
              color: #1A1A1A;
            }

            &.content-grid {
              grid-template-columns: 40px 1fr;
              align-items: flex-start;

              .check-div {
                padding-left: 10px;

                .v-input--checkbox {
                  transform: scale(.75);
                  padding: 0 !important;
                  top: -5px;
                  position: relative;

                  i {
                    font-size: 23px;
                    color: #1A1A1A !important;
                  }
                }

                .v-input__slot {
                  margin: 0 !important;
                }

                .v-messages {
                  display: none;
                }

                .v-input--selection-controls__ripple {
                  display: none;
                }

                .v-input--checkbox {
                  margin-top: 0 !important;
                }
              }

              .task-topic {
                color: #1A1A1A;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 700;
                font-size: 13px;
                line-height: 16px;
                display: block;
                margin-bottom: 4px;
              }
            }
          }
        }
      }

      &__history {
        padding: 0;

        &__item {
          display: flex;
          align-items: center;

          &:not(:last-child) {
            margin-bottom: 10px;
          }

          .action {
            color: #767676;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;

            .status {
              background: #EFF5EB;
              border-radius: 25px;
              padding: 4px 10px;
              color: #629F33;
              font-family: 'Circe';
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              line-height: 16px;
            }
          }

          .separator {
            transform: rotate(-90deg);
            padding: 0 14px;
          }
        }
      }

    }
  }
}


.my-btn {
  border-radius: 12px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  border: none;
  box-shadow: unset;
  padding: 8px 12px;

  &.green {
    background: #E0ECD6 !important;
    color: #629F33;
  }

  &.text {
    background: unset !important;
    color: #767676;
  }

  &.gray {
    width: unset !important;
  }

  &.red {
    background: #D53025 !important;
    color: #fff !important;
  }

  &.border-green {
    background: unset !important;
    color: #629F33;
    border: 1px solid #629F33;
  }

  &.margin-right-20 {
    margin-right: 20px;
  }
}

.modal-content {
  .block {
    background: #fff;
    border: 1px solid #E0E0E0;
    border-radius: 12px;

    &.padding-20 {
      padding: 20px;
    }

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .block-button {
      padding: 20px 0 20px 20px;
    }

    .label {
      color: #1A1A1A;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.padding-20 {
        padding: 20px;
      }

      .status {
        background: #FFB800;
        border-radius: 25px;
        padding: 4px 10px;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
    }

    .relatives {
      table {
        border-collapse: collapse;
        width: 100%;

        thead {
          th {
            background: #F1F1F1;
            font-weight: bold;
          }
        }

        th,
        td {
          background: #fff;
          padding: 7px 12px;
          text-align: left;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          color: #000000;
          border: 1px solid #E0E0E0 !important;
        }

        td {
          .relative {
            display: flex;
            align-items: center;

            .ava {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              margin-right: 8px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }

  .client-photo {
    display: flex;
    flex-direction: column;
    align-items: center;

    .photo {
      width: 210px;
      height: 210px;
      background: #F1F1F1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-top: 19px;
      margin-bottom: 20px;
    }

    .block-btn {
      margin-bottom: 20px;
    }
  }

  .form {
    padding-top: 20px;

    &__field {
      &.padding-top-30 {
        padding-top: 30px;
      }

      .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
        height: 48px;
      }

      .v-input__slot {
        height: 55px !important;
        max-height: 55px !important;

        fieldset {
          height: 55px !important;
          max-height: 55px !important;
        }

        .v-text-field__slot {
          height: 50px !important;
        }
      }

      &.w-100 {
        width: 100%;
      }
    }

  }
}

.custom__date-button {
  background: none !important;
  border: 1px solid #E0E0E0 !important;
  padding: 12px 16px !important;
  width: 100% !important;
  color: #767676 !important;

  .v-icon {
    color: #767676 !important;
    font-size: 20px !important;
  }

  .full-width {
    flex: 1;
    text-align: left;
  }
}

.payment-form {
  &__item {
    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .v-btn-toggle {
      margin: 0 !important;
    }

    // .v-select__slot,
    // fieldset,
    // .v-text-field__slot,
    // .v-input__slot,
    .v-input__control,
    .v-input__slot {
      max-height: 48px !important;
      min-height: 48px !important;
      height: 48px !important;
    }

    .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
      height: 48px !important;
    }

    .theme--light.v-btn.v-btn--has-bg {
      background-color: #fff;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-transform: none;
    }

    .v-select__selections {
      padding: 0 !important;
    }

    .theme--light.v-btn--active:hover::before,
    .theme--light.v-btn--active::before {
      opacity: 0;
    }


    .line {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 65%;
      gap: 10px;

      span {
        flex: 1;
        text-align: right;
      }

      .v-btn-toggle {
        margin: 0 !important;

        .v-btn__content {
          font-family: 'Circe';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          // color: #629F33;
          display: flex;
          align-items: center;
          text-transform: none;

          svg {
            margin-right: 10px;
          }

          .v-btn {
            background: #fff !important;
          }

          &--active {
            background: #fff !important;
          }
        }
      }
    }

    .collumn-3 {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 21px;

      .disabled {
        background: #F1F1F1;
      }
    }
  }
}

.relatives-block {
  &.see {
    padding-top: 30px;
  }

  .toggle-line {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .form-grid {
    &__line {
      display: grid;
      grid-template-columns: repeat(3, calc(33.3333% - 18px));
      gap: 18px;

      &.line-col-2 {
        align-items: center;
        grid-template-columns: calc(33.3333% - 18px) 1fr;

        .label {
          // margin-bottom: 0;
        }
      }

      &.margin-bottom-20 {
        margin-bottom: 20px;
      }

      &__field {
        &.requred {
          .label {
            &::after {
              content: " *";
              color: #D53025;
            }
          }
        }

        &.colspan-2 {
          grid-column: 1 / 3;
        }

        &.button-block {
          display: flex;
          align-items: center;
        }

        .label {
          display: inline-block;
          margin-bottom: 8px;

          &.opacity-0 {
            opacity: 0;
          }
        }

        .v-autocomplete {
          .v-select__slot {
            height: 48px;

            input {
              margin: 0 !important;
            }
          }
        }

        input {
          margin: 8px 0;
        }

        .vd-activator {
          margin: 0 !important;
          padding: 0 !important;

          .custom__date-button {
            justify-content: space-between;
            box-sizing: border-box;
            min-width: 100% !important;
            height: 48px !important;

            i {
              margin: 0 !important;
              padding: 0 !important;
            }
          }
        }

        .v-item-group {
          border-radius: 12px !important;
          background: #fff !important;

          button {
            font-family: 'Circe';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            text-transform: none;
            background: #fff !important;
            height: 48px !important;

            &::before {
              display: none;
            }
          }
        }

        .v-select__slot {

          .v-select__selections {
            input {
              padding: 0 !important;
              margin: 10px 0 !important;
            }
          }

          .v-input__append-inner {
            margin-top: 12px !important;
          }
        }

        i {
          color: #767676 !important;
          caret-color: #767676 !important;
        }

        .dt-error {
          line-height: 12px;
          word-break: break-word;
          overflow-wrap: break-word;
          word-wrap: break-word;
          -webkit-hyphens: auto;
          -ms-hyphens: auto;
          hyphens: auto;
          color: #ff5252;
          font-size: 12px;
          padding: 0 12px;
          padding-top: 4px;
          margin-bottom: -10px;
        }
      }

      .link-btn {
        border: 1px solid #629F33;
        border-radius: 12px;
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        text-decoration: none;
        color: #629F33;
        margin-top: 30px;
      }
    }

    button {

      &[type="submit"],
      &.delete {
        background: #629F33;
        border-radius: 12px;
        padding: 12px 20px;
        box-shadow: none;
        text-transform: none;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        height: unset !important;
        margin-top: 0 !important;
      }

      &.delete {
        background: #D53025;
        margin-left: 19px;
      }
    }
  }
}

.new-task {
  &.card {
    padding: 0 24px;

    .grid-line {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .v-text-field__slot {
        height: 48px;
      }

      button {
        background: #A13453 !important;
        border-radius: 12px;
        text-transform: none;
        padding: 0 20px;
        display: flex;
        align-items: center;
        margin-top: 0px !important;
        margin-left: 8px;
        box-shadow: unset !important;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #FFFFFF;
        height: 48px !important;
        min-height: 48px !important;
      }
    }

    .button-block {
      padding-top: 40px;
      justify-content: center;

      button {
        &[type="submit"] {
          padding: 12px 20px;
          height: unset !important;
        }

        &[disabled] {
          color: #1A1A1A !important;
        }
      }
    }
  }

  &.card-edit {
    form {
      width: 288px;
      margin: auto;

      .form-field {
        &:not(:last-child) {
          margin-bottom: 10px;
        }

        .v-input__slot {
          height: 48px;
          min-height: 48px;
          max-height: 48px;
        }
      }

      .message-hint {
        color: #767676;
        text-align: center;
        padding-top: 20px;
      }

      .button-block {
        padding-top: 42px;
        justify-content: center;

        button {
          &[type="submit"] {
            padding: 12px 20px;
            height: unset !important;
            background: #D53025 !important;
          }
        }
      }
    }
  }

  .heading {
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;

    color: #000000;
    margin-bottom: 24px;
  }

  .form-field {
    .label {
      color: #1A1A1A;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      display: block;
      margin-bottom: 8px;
    }
  }

  .button-block {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      &[type="submit"] {
        background: #629F33;
        border-radius: 12px;
        padding: 8px 20px;
        box-shadow: none;
        text-transform: none;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

}

.edit-avatar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.edit-button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-avatar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto 0;
  width: 210px;
  height: 210px;
  border-radius: 145px;
  background-color: #F1F1F1;
}

.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}
</style>